import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./jobPosting.module.css";
import Footer from "../../components/footer";
import PriceRange from "./PriceRange";
import { createJob } from "../../redux/slices/jobPostingSlice";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { notifyError, notifySuccess } from "../../utils";
import DynamicForm from "../../components/DynamicForm";
import useAuth from "../../hooks/useAuth";
import LoginPopup from "../../components/LoginPopup";

const ANDJobPosting = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const user = useAuth();
  const [formData, setFormData] = useState({
    isFlexible: false,
    projectName: "",
    currency: "USD",
    artistType: "",
    projectSize: "",
    location: "",
    budget: "",
    isGrant: false,
    timeline: {
      type: "", // "on-date", "before-date", "flexible"
      startdate: null,
      enddate: null,
    },
    contactType: "individual", // "individual" or "organization"
    phone: "",
    heardFrom: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    subscribeNewsletter: false,
    agreedToTerms: false,
    skillsRequired: [],
    transportation_provided: false,
    venue_provided: false,
    equipment_provided: false,
  });
  const dispatch = useDispatch();

  console.log("formdata is ", formData);

  // Artist type options expanded to include various artists
  const artistTypes = [
    { id: "musician", label: "Musicians & Bands", icon: "🎶" },

    { id: "singer", label: "Singers ", icon: "🎤" },
    { id: "photographers", label: "Photographers", icon: "📷" },
    { id: "videoEditors", label: "Videographers & Editors", icon: "🎬" },
    { id: "dancers", label: "Dancers & Choreographers", icon: "💃" },
    { id: "magicians", label: "Magicians & Illusionists", icon: "✨" },
    { id: "comedians", label: "Comedians & Entertainers", icon: "🎭" },
    { id: "djs", label: "DJs & Sound Artists", icon: "🎧" },
  ];

  const artistSkills = {
    musician: [
      { key: "instrument_playing", label: "Instrument Playing" },
      { key: "music_theory", label: "Music Theory" },
      { key: "live_performance", label: "Live Performance" },
      { key: "composition", label: "Music Composition" },
      { key: "band_coordination", label: "Band Coordination" },
    ],
    singer: [
      { key: "vocal_control", label: "Vocal Control" },
      { key: "stage_presence", label: "Stage Presence" },
      { key: "mic_technique", label: "Mic Technique" },
      { key: "song_interpretation", label: "Song Interpretation" },
      { key: "guitar_playing", label: "Guitar Playing" },
    ],
    photographers: [
      { key: "photo_editing", label: "Photo Editing" },
      { key: "portrait_photography", label: "Portrait Photography" },
      { key: "event_photography", label: "Event Photography" },
      { key: "lighting_techniques", label: "Lighting Techniques" },
      { key: "camera_handling", label: "Camera Handling" },
    ],
    videoEditors: [
      { key: "video_editing", label: "Video Editing" },
      { key: "motion_graphics", label: "Motion Graphics" },
      { key: "color_grading", label: "Color Grading" },
      { key: "audio_syncing", label: "Audio Syncing" },
      { key: "storyboarding", label: "Storyboarding" },
    ],
    dancers: [
      { key: "freestyle", label: "Freestyle Dance" },
      { key: "choreography", label: "Choreography" },
      { key: "ballet", label: "Ballet" },
      { key: "hip_hop", label: "Hip Hop" },
      { key: "contemporary", label: "Contemporary Dance" },
    ],
    magicians: [
      { key: "card_tricks", label: "Card Tricks" },
      { key: "stage_magic", label: "Stage Magic" },
      { key: "sleight_of_hand", label: "Sleight of Hand" },
      { key: "illusions", label: "Illusions" },
      { key: "crowd_engagement", label: "Crowd Engagement" },
    ],
    comedians: [
      { key: "standup", label: "Stand-Up Comedy" },
      { key: "improv", label: "Improvisation" },
      { key: "timing", label: "Comic Timing" },
      { key: "storytelling", label: "Storytelling" },
      { key: "audience_interaction", label: "Audience Interaction" },
    ],
    djs: [
      { key: "mixing", label: "Mixing Tracks" },
      { key: "beatmatching", label: "Beatmatching" },
      { key: "live_dj_sets", label: "Live DJ Sets" },
      { key: "sound_design", label: "Sound Design" },
      { key: "crowd_reading", label: "Crowd Reading" },
    ],
  };

  let timerId;
  useEffect(() => {
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    if (!user?.isAuthenticated) {
      setShowLoginPopup(true);
    }
  }, [user]);

  // Project sizes
  const projectSizes = [
    { id: "small", label: "Small (1 day events)" },
    { id: "medium", label: "Medium (2 day evevnts)" },

    { id: "large", label: "Extended (Multi-day event)" },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleTimelineChange = (type, value = null) => {
    setFormData({
      ...formData,
      timeline: {
        ...formData.timeline,
        [type === "on-date" ? "startdate" : "enddate"]: value,
      },
    });
  };

  const handleSkillsChnange = (data) => {
    setFormData({
      ...formData,
      skillsRequired: data.skillsRequired,
    });
  };

  const handleContactTypeChange = (type) => {
    setFormData({
      ...formData,
      contactType: type,
    });
  };

  const handleArtistTypeSelect = (type) => {
    setFormData({
      ...formData,
      artistType: type,
    });
  };

  const handleProjectSizeSelect = (size) => {
    setFormData({
      ...formData,
      projectSize: size,
    });
  };

  const handleNext = () => {
    if (currentStep === 1) {
      if (formData?.projectName?.length < 10) {
        notifyError("Project name should be of atlead 10 characters ");
        return;
      }
    } else if (currentStep === 2) {
      if (formData?.description?.length < 10) {
        notifyError("Project description should be of atlead 10 characters ");
        return;
      }
    }
    setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const calculateDays = (projectSizes) => {
    switch (projectSizes) {
      case "small":
        return 1;
      case "medium":
        return 2;
      case "large":
        return 3;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData?.phone?.length !== 10) {
      notifyError("Mobile number should contain 10 letters!");
      return;
    }
    // Handle form submission here - connect to your API
    console.log("Form submitted:", formData);
    const startDate = new Date(formData.timeline.startdate);
    const endDate = new Date(formData.timeline.enddate);

    try {
      await dispatch(
        createJob({
          category: formData.artistType,
          title: formData.projectName,
          description: formData.description,
          budget: formData.budget,
          startdate: startDate.toISOString(),
          address: formData.location,
          equipment_provided: formData.providesEquipment || false,
          transportation_provided: formData.providesTransport || false,
          venue_provided: formData.providesVenue || false,
          duration_days: calculateDays(formData.projectSize),
          phonenumber: formData.phone,
          enddate: endDate.toISOString(),
          skills_required: formData.skillsRequired,
        })
      ).unwrap(); // if using createAsyncThunk from Redux Toolkit
      notifySuccess("Job created successfully!");
      timerId = setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      console.log(error);
      notifyError("Something went wrong");
      // Optionally, show a toast or UI message here
    }

    // Reset form or redirect
    // alert("Job posted successfully!");
    // navigate("/dashboard"); // Redirect to dashboard or success page
  };

  const isStepValid = () => {
    switch (currentStep) {
      case 1:
        return (
          formData.projectName &&
          formData.artistType &&
          formData.projectSize &&
          formData.location
        );
      case 2:
        return (
          formData.description &&
          formData?.skillsRequired?.length > 0 &&
          (formData.providesEquipment !== null ||
            formData.providesVenue !== null ||
            formData.providesTransport !== null)
        );
      case 3:
        return (
          formData.budget &&
          formData.timeline.startdate &&
          formData.timeline.enddate
        );
      case 4:
        return formData.contactType && formData.agreedToTerms;
      default:
        return false;
    }
  };

  return (
    <>
      <ToastContainer />
      {showLoginPopup && <LoginPopup />}
      <div className={classes.jobPostingContainer}>
        <div className={classes.header}>
          <h1>Post a job</h1>
        </div>

        <div className={classes.content}>
          <div className={classes.sidebar}>
            <div className={classes.stepsContainer}>
              <div className={classes.stepLabel}>Step {currentStep} of 4</div>
              <div className={classes.stepTitle}>
                Share details about the project
              </div>

              <div className={classes.steps}>
                <div
                  className={`${classes.step} ${
                    currentStep >= 1 ? classes.completed : ""
                  } ${currentStep === 1 ? classes.active : ""}`}
                >
                  <div className={classes.stepCircle}>
                    {currentStep > 1 ? "✓" : 1}
                  </div>
                  <div className={classes.stepText}>Project Detail</div>
                </div>

                <div
                  className={`${classes.step} ${
                    currentStep >= 2 ? classes.completed : ""
                  } ${currentStep === 2 ? classes.active : ""}`}
                >
                  <div className={classes.stepCircle}>
                    {currentStep > 2 ? "✓" : 2}
                  </div>
                  <div className={classes.stepText}>Project Requirements</div>
                </div>

                <div
                  className={`${classes.step} ${
                    currentStep >= 3 ? classes.completed : ""
                  } ${currentStep === 3 ? classes.active : ""}`}
                >
                  <div className={classes.stepCircle}>
                    {currentStep > 3 ? "✓" : 3}
                  </div>
                  <div className={classes.stepText}>Budget & Timeline</div>
                </div>

                <div
                  className={`${classes.step} ${
                    currentStep >= 4 ? classes.completed : ""
                  } ${currentStep === 4 ? classes.active : ""}`}
                >
                  <div className={classes.stepCircle}>
                    {currentStep > 4 ? "✓" : 4}
                  </div>
                  <div className={classes.stepText}>Contact Information</div>
                </div>
              </div>
            </div>
          </div>

          <div className={classes.formContainer}>
            <div className={classes.formHeader}>
              {currentStep === 1 && <h2>Basic details</h2>}
              {currentStep === 2 && <h2>Project Requirements</h2>}
              {currentStep === 3 && <h2>Budget & Timeline</h2>}
              {currentStep === 4 && <h2>Contact Information</h2>}
            </div>

            <form onSubmit={handleSubmit}>
              {/* Step 1: Project Details */}
              {currentStep === 1 && (
                <div className={classes.formStep}>
                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Give your project a name
                    </label>
                    <input
                      type="text"
                      name="projectName"
                      value={formData.projectName}
                      onChange={handleChange}
                      placeholder="e.g., Birthday Party Performance"
                      className={classes.textInput}
                      required
                    />
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      What kind of artist are you looking for?
                    </label>
                    <div className={classes.artistTypesGrid}>
                      {artistTypes.map((type) => (
                        <div
                          key={type.id}
                          className={`${classes.artistTypeCard} ${
                            formData.artistType === type.id
                              ? classes.selected
                              : ""
                          }`}
                          onClick={() => handleArtistTypeSelect(type.id)}
                        >
                          <div className={classes.artistTypeIcon}>
                            {type.icon}
                          </div>
                          <div className={classes.artistTypeLabel}>
                            {type.label}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Select the project size
                    </label>
                    <div className={classes.projectSizeGrid}>
                      {projectSizes.map((size) => (
                        <div
                          key={size.id}
                          className={`${classes.projectSizeCard} ${
                            formData.projectSize === size.id
                              ? classes.selected
                              : ""
                          }`}
                          onClick={() => handleProjectSizeSelect(size.id)}
                        >
                          {size.label}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Address of the project
                    </label>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      placeholder="Enter city, state, country"
                      className={classes.textInput}
                      required
                    />
                  </div>

                  <div className={classes.navigationButtons}>
                    <button
                      type="button"
                      className={classes.continueButton}
                      onClick={handleNext}
                      disabled={!isStepValid()}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              )}

              {/* Step 2: Project Requirements */}
              {currentStep === 2 && (
                <div className={classes.formStep}>
                  <div className={classes.formGroup}>
                    <label className={classes.label}>
                      Please describe what you're looking for
                    </label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Provide details about your project, expectations, and what you need from the artist..."
                      className={classes.textareaInput}
                      rows={6}
                    />
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.label}>Skills required</label>
                    {/* <textarea
                      name="requiredSkills"
                      value={formData.requiredSkills}
                      onChange={handleChange}
                      placeholder="List any specific skills, experience, or qualifications you're looking for..."
                      className={classes.textareaInput}
                      rows={4}
                    /> */}
                    <div style={{ marginTop: "-10px" }}>
                      <DynamicForm
                        setOnboardingData={(data) => {
                          handleSkillsChnange(data);
                        }}
                        handleNextStep={() => {}}
                        fields={[
                          {
                            type: "pills",
                            showTitle: false,
                            name: "skillsRequired",
                            isMultiSelect: true,

                            options: artistSkills[formData?.artistType],
                          },
                        ]}
                      />
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.label}>
                      Equipment or materials provided
                    </label>
                    <div className={classes.checkboxGroup}>
                      <label className={classes.checkboxLabel}>
                        <input
                          type="checkbox"
                          name="providesEquipment"
                          checked={formData.providesEquipment}
                          onChange={handleChange}
                        />
                        I will provide all necessary equipment
                      </label>
                    </div>
                    <div className={classes.checkboxGroup}>
                      <label className={classes.checkboxLabel}>
                        <input
                          type="checkbox"
                          name="providesVenue"
                          checked={formData.providesVenue}
                          onChange={handleChange}
                        />
                        I will provide the venue
                      </label>
                    </div>
                    <div className={classes.checkboxGroup}>
                      <label className={classes.checkboxLabel}>
                        <input
                          type="checkbox"
                          name="providesTransport"
                          checked={formData.providesTransport}
                          onChange={handleChange}
                        />
                        I will arrange transportation
                      </label>
                    </div>
                  </div>

                  <div className={classes.navigationButtons}>
                    <button
                      type="button"
                      className={classes.backButton}
                      onClick={handleBack}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className={classes.continueButton}
                      onClick={handleNext}
                      disabled={!isStepValid(2)}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              )}

              {/* Step 3: Budget & Timeline */}
              {currentStep === 3 && (
                <div className={classes.formStep}>
                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      What's your approximate budget?
                    </label>
                    <div className={classes.inputGroup}>
                      <PriceRange setFormData={setFormData} name="budget" />
                      {/* <select
                        name="currency"
                        value={formData.currency}
                        onChange={handleChange}
                        className={classes.currencySelect}
                      >
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                        <option value="INR">INR</option>
                      </select> */}
                    </div>

                    <div className={classes.checkboxGroup}>
                      <label className={classes.checkboxLabel}>
                        <input
                          type="checkbox"
                          name="isGrant"
                          checked={formData.isGrant}
                          onChange={handleChange}
                        />
                        I am applying for a council/government grant
                      </label>
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Start date for this job
                    </label>
                    <div className={classes.timelineOptions}>
                      <input
                        type="date"
                        value={formData.timeline.startdate || ""}
                        onChange={(e) =>
                          handleTimelineChange("on-date", e.target.value)
                        }
                        className={classes.dateInput}
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Deadline for this job
                    </label>
                    <div className={classes.timelineOptions}>
                      <input
                        type="date"
                        value={formData.timeline.enddate || ""}
                        onChange={(e) =>
                          handleTimelineChange("deadline", e.target.value)
                        }
                        className={classes.dateInput}
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                    <label
                      style={{ marginTop: "10px" }}
                      className={classes.checkboxLabel}
                    >
                      <input
                        type="checkbox"
                        name="isFlexible"
                        checked={formData.isFlexible}
                        onChange={handleChange}
                      />
                      I am flexible for date
                    </label>
                  </div>

                  <div className={classes.navigationButtons}>
                    <button
                      type="button"
                      className={classes.backButton}
                      onClick={handleBack}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className={classes.continueButton}
                      onClick={handleNext}
                      disabled={!isStepValid(3)}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              )}

              {/* Step 4: Contact Information */}
              {currentStep === 4 && (
                <div className={classes.formStep}>
                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Are you representing an organisation or is this project
                      for personal interest?
                    </label>
                    <div className={classes.contactTypeOptions}>
                      <div
                        className={`${classes.contactTypeOption} ${
                          formData.contactType === "organization"
                            ? classes.selected
                            : ""
                        }`}
                        onClick={() => handleContactTypeChange("organization")}
                      >
                        <div className={classes.contactTypeIcon}>🏢</div>
                        <div className={classes.contactTypeLabel}>
                          Organization
                        </div>
                      </div>
                      <div
                        className={`${classes.contactTypeOption} ${
                          formData.contactType === "individual"
                            ? classes.selected
                            : ""
                        }`}
                        onClick={() => handleContactTypeChange("individual")}
                      >
                        <div className={classes.contactTypeIcon}>👤</div>
                        <div className={classes.contactTypeLabel}>
                          An Individual
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.requiredLabel}>
                      Phone Number
                    </label>
                    <div className={classes.phoneInputGroup}>
                      {/* <select
                        name="phoneCountryCode"
                        value={formData.phoneCountryCode}
                        onChange={handleChange}
                        className={classes.countryCodeSelect}
                      >
                        <option value="+1">+91 (IN)</option>
                        <option value="+44">+44 (UK)</option>
                        <option value="+91">+91 (IN)</option>
                        <option value="+61">+61 (AU)</option>
                        <option value="+33">+33 (FR)</option>
                      </select> */}
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                        className={classes.phoneInput}
                        required
                      />
                    </div>
                  </div>

                  <div className={classes.formGroup}>
                    <label className={classes.label}>
                      How did you hear about ArtistNextDoor? (Optional)
                    </label>
                    <select
                      name="heardFrom"
                      value={formData.heardFrom}
                      onChange={handleChange}
                      className={classes.selectInput}
                    >
                      <option value="">Select an option</option>
                      <option value="search">Search Engine</option>
                      <option value="social">Social Media</option>
                      <option value="friend">Friend or Colleague</option>
                      <option value="event">Event or Performance</option>
                      <option value="advertisement">Advertisement</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className={classes.personalDetails}>
                    <div className={classes.sectionTitle}>
                      Please share your personal details.
                    </div>
                    {/* <div className={classes.formRow}>
                      <div className={classes.formColumn}>
                        <label className={classes.requiredLabel}>
                          First Name
                        </label>
                        <input
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          className={classes.textInput}
                          required
                        />
                      </div>
                      <div className={classes.formColumn}>
                        <label className={classes.requiredLabel}>
                          Last Name
                        </label>
                        <input
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          className={classes.textInput}
                          required
                        />
                      </div>
                    </div>

                    <div className={classes.formRow}>
                      <div className={classes.formColumn}>
                        <label className={classes.requiredLabel}>Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={classes.textInput}
                          required
                        />
                      </div>
                      <div className={classes.formColumn}>
                        <label className={classes.requiredLabel}>
                          Create password
                        </label>
                        <div className={classes.passwordInputGroup}>
                          <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className={classes.passwordInput}
                            required
                          />
                          <button
                            type="button"
                            className={classes.passwordToggle}
                          >
                            👁️
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className={classes.divider}>
                      <span>OR</span>
                    </div>

                    <div className={classes.socialLoginOptions}>
                      <button type="button" className={classes.googleButton}>
                        <span className={classes.googleIcon}>G</span>
                        Continue with Google
                      </button>
                      <button type="button" className={classes.appleButton}>
                        <span className={classes.appleIcon}>
                          <svg viewBox="0 0 24 24" width="18" height="18">
                            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z" />
                          </svg>
                        </span>
                        Continue with Apple
                      </button>
                    </div> */}

                    <div className={classes.checkboxGroup}>
                      <label className={classes.checkboxLabel}>
                        <input
                          type="checkbox"
                          name="subscribeNewsletter"
                          checked={formData.subscribeNewsletter}
                          onChange={handleChange}
                        />
                        Stay in the loop! Subscribe to our newsletter?
                      </label>
                    </div>

                    <div className={classes.checkboxGroup}>
                      <label className={classes.checkboxLabel}>
                        <input
                          type="checkbox"
                          name="agreedToTerms"
                          checked={formData.agreedToTerms}
                          onChange={handleChange}
                          required
                        />
                        I agree to ArtistNextDoor's{" "}
                        <a href="/terms" className={classes.link}>
                          Terms of Service
                        </a>{" "}
                        and{" "}
                        <a href="/privacy" className={classes.link}>
                          Privacy Policy
                        </a>
                        .
                      </label>
                    </div>

                    <div className={classes.recaptcha}>
                      {/* Recaptcha would be implemented here */}
                      <div className={classes.recaptchaPlaceholder}>
                        I'm not a robot [ reCAPTCHA ]
                      </div>
                    </div>
                  </div>

                  <div className={classes.navigationButtons}>
                    <button
                      type="button"
                      className={classes.backButton}
                      onClick={handleBack}
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      className={classes.submitButton}
                      disabled={!isStepValid(4)}
                    >
                      Save & submit
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>

          <div className={classes.tipsContainer}>
            <div className={classes.tipsContent}>
              <div className={classes.tipsHeader}>
                <div className={classes.tipsIcon}>💡</div>
                <h3>Tips</h3>
              </div>

              <div className={classes.tipsList}>
                <div className={classes.tip}>
                  <h4>Standout with a good title</h4>
                  <p>
                    Give your project a standout title - this is what artists
                    will see first!
                  </p>
                </div>

                <div className={classes.tip}>
                  <h4>Be detailed</h4>
                  <p>
                    Give as much detail as possible. This helps artists
                    determine if they are suited for the project or not.
                  </p>
                </div>

                <div className={classes.tip}>
                  <h4>Share initial ideas</h4>
                  <p>
                    It helps to give the artist as much insight and ideas around
                    the project as possible. Providing a detailed description
                    has a higher response rate.
                  </p>
                </div>

                <div className={classes.tip}>
                  <h4>Provide accurate budget</h4>
                  <p>
                    Not sure how much your project might cost? Try our{" "}
                    <a href="/pricing-calculator" className={classes.link}>
                      pricing calculator
                    </a>{" "}
                    to get an idea.
                  </p>
                </div>

                <div className={classes.helpText}>
                  Need assistance? Please{" "}
                  <a href="/login" className={classes.link}>
                    login
                  </a>{" "}
                  and contact support.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ANDJobPosting;
